var map = {
	"./DOWN.png": "Qv75",
	"./DOWN@2x.png": "T4vw",
	"./GIU.png": "N2N6",
	"./Line 3.png": "v1UJ",
	"./Line 3@2x.png": "wsOm",
	"./Path 1@2x.png": "KANO",
	"./Path1.png": "piUr",
	"./Polygon 2@2x.png": "PS4R",
	"./Polygon2.png": "n1sc",
	"./Rectangle 16.png": "7zJp",
	"./Rectangle 16@2x.png": "j4mz",
	"./Rectangle 9.png": "B2us",
	"./Rectangle 9@2x.png": "xZsx",
	"./SU.png": "SweQ",
	"./Scroll Group 1.png": "6uY6",
	"./Scroll Group 1@2x.png": "0xY3",
	"./UP.png": "nMjb",
	"./UP@2x.png": "cPOc",
	"./Zasob10.png": "XyPV",
	"./Zasob11.png": "t3Ew",
	"./Zasob12.png": "nZhk",
	"./Zasob13.png": "qUEP",
	"./Zasob14.png": "BR4A",
	"./Zasob15.png": "iBGY",
	"./Zasob16.png": "0M2Z",
	"./Zasob17.png": "fYke",
	"./Zasob18.png": "bs37",
	"./Zasob3.png": "jCqM",
	"./Zasob5.png": "Rt/K",
	"./Zasób -1.png": "fAqR",
	"./Zasób -1@2x.png": "YGvK",
	"./Zasób 10@2x.png": "DOkQ",
	"./Zasób 11@2x.png": "9VVc",
	"./Zasób 12@2x.png": "F72x",
	"./Zasób 13@2x.png": "+t2h",
	"./Zasób 14@2x.png": "TghT",
	"./Zasób 15@2x.png": "HJ4E",
	"./Zasób 16@2x.png": "3uTv",
	"./Zasób 17@2x.png": "GmmR",
	"./Zasób 18@2x.png": "yke0",
	"./Zasób 1@2x.png": "vTog",
	"./Zasób 3@2x.png": "zW1F",
	"./Zasób 4 - pionowy.png": "FLL6",
	"./Zasób 4.png": "uOwd",
	"./Zasób 4@2x.png": "pxXA",
	"./Zasób 5@2x.png": "j5Dj",
	"./americano.png": "fW9c",
	"./americano@2x.png": "v3sn",
	"./caffe_latte.png": "VRZL",
	"./caffe_latte@2x.png": "95iU",
	"./cappuccino.png": "MLpf",
	"./cappuccino@2x.png": "JnrH",
	"./coffee-1548766_1920 (1)_1.jpg": "4dAj",
	"./coffee-1548766_1920_640px.jpg": "K4pR",
	"./coffee-4042935_1920.png": "HX4J",
	"./coffee-66850_1280.png": "eW3i",
	"./coffee-66850_1280@2x.png": "zXIA",
	"./coffee-beans-5712774_1920.png": "a+UN",
	"./coffee-beans-5712774_1920@2x.png": "AnPb",
	"./coretto.png": "NcjS",
	"./coretto@2x.png": "7iO1",
	"./doppio.png": "n0oK",
	"./doppio@2x.png": "RIxN",
	"./espresso-z-cukrem.png": "Ehud",
	"./espresso-z-cukrem@2x.png": "3RQn",
	"./favi_icon_16px.png": "sjyN",
	"./favi_icon_36px.png": "xNnN",
	"./florence-1655830_1920.png": "xfxO",
	"./florence-1655830_1920@2x.png": "yAWm",
	"./gb_flag.png": "roPY",
	"./hamb64x64.png": "NhMs",
	"./ice_coffee.png": "r365",
	"./ice_coffee@2x.png": "iSt/",
	"./it_flag.png": "QYTZ",
	"./latte.png": "NkrA",
	"./latte@2x.png": "0gRU",
	"./liscie.jpg": "kshD",
	"./lisciemobile.jpg": "xYsL",
	"./logo.png": "fARU",
	"./lungo.png": "iPEM",
	"./lungo@2x.png": "S1uz",
	"./paczki.png": "TWYN",
	"./paczki@2x.png": "EwuA",
	"./paczki_osobno_gold.png": "NT5e",
	"./paczki_osobno_gold@2x.png": "iCaY",
	"./paczki_osobno_silver.png": "d7Cw",
	"./paczki_osobno_silver@2x.png": "WHg3",
	"./panna.png": "AiFS",
	"./panna@.png": "d95Z",
	"./ristretto.png": "AVwD",
	"./ristretto@2x.png": "QWuk",
	"./stock-photo-top-view-serious-bearded-worker-near-coffee-roaster-controlling-level-of-grain-roasting-revise-755543239.png": "hMOM",
	"./stock-photo-top-view-serious-bearded-worker-near-coffee-roaster-controlling-level-of-grain-roasting-revise-755543239@2x.png": "KDAQ",
	"./szklanki.png": "UZrh",
	"./szklanki@2x.png": "yKYE",
	"./tlo_palenie.png": "qGim",
	"./tlo_palenie@2x.png": "Syw2",
	"./tlo_wenecja.png": "rZ6Q",
	"./tlo_wenecja640px.png": "ydXX",
	"./tlo_wenecja@2x.png": "ZFzU",
	"./venice-1035684_1920.png": "hcjW",
	"./venice-1035684_1920@2x.png": "chXq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lc2H";